import React from 'react';
import classNames from 'classnames';

import css from './Icons.module.css'

const ManequinIcon = ({ className, viewBox }) => {
    return (

        <svg
            xmlns="http://www.w3.org/2000/svg"
            id="a"
            viewBox="0 0 45.267 44.804"
            className={classNames(css.root, className)}
        >
            <path fill="none" strokeWidth="0" d="M.238.116h45.189V44.86H.238z"></path>
            <path
                fill="none"
                stroke="#535454"
                strokeMiterlimit="10"
                strokeWidth="1.25"
                d="M12.414 1.713s-.067 1.407-.804 1.876-3.484 1.005-3.752 1.742-.335 1.675 1.407 5.159.804 6.567.067 8.309-2.077 4.623-1.407 5.83 2.077 2.412 5.964 2.345"
            ></path>
            <path
                fill="none"
                stroke="#535454"
                strokeMiterlimit="10"
                strokeWidth="1.25"
                d="M15.276 1.713s.067 1.407.804 1.876 3.484 1.005 3.752 1.742.335 1.675-1.407 5.159-.804 6.567-.067 8.309 2.077 4.623 1.407 5.83-2.077 2.412-5.964 2.345"
            ></path>
            <path
                fill="none"
                stroke="#535454"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.25"
                d="M13.958 26.98v9.402M8.189 38.316c0-1.026 2.605-1.858 5.818-1.858s5.818.832 5.818 1.858"
            ></path>
            <path
                fill="none"
                stroke="#535454"
                strokeLinecap="square"
                strokeMiterlimit="10"
                strokeWidth="1.25"
                d="M12.32 1.679h3.047"
            ></path>
            <path
                fill="none"
                stroke="#535454"
                strokeMiterlimit="10"
                strokeWidth="1.25"
                d="M30.389 6.695s-.067 1.407-.804 1.876-3.484 1.005-3.752 1.742-.335 1.675 1.407 5.159.804 6.567.067 8.309-2.077 4.623-1.407 5.83 2.077 2.412 5.964 2.345"
            ></path>
            <path
                fill="none"
                stroke="#535454"
                strokeMiterlimit="10"
                strokeWidth="1.25"
                d="M36.606 24.419c.745 1.741 1.728 4.123 1.135 5.192-.67 1.206-2.077 2.412-5.964 2.345"
            ></path>
            <path
                fill="none"
                stroke="#535454"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.25"
                d="M36.237 23.279q.172.536.369 1.141M33.251 6.695s.067 1.407.804 1.876 3.484 1.005 3.752 1.742.335 1.675-1.407 5.159a9.1 9.1 0 0 0-.981 3.701M31.933 31.962v9.389M26.164 43.298c0-1.026 2.605-1.858 5.818-1.858s5.818.832 5.818 1.858"
            ></path>
            <path
                fill="none"
                stroke="#535454"
                strokeLinecap="square"
                strokeMiterlimit="10"
                strokeWidth="1.25"
                d="M30.295 6.661h3.047"
            ></path>
        </svg>
    );
};

export default ManequinIcon;
